// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m1_Q","colBig":"styles_colBig__26jPE","colSmall":"styles_colSmall__254qm"};